<template>
  <div style="display: inline-flex;">
    <template v-if="Array.isArray(data)">
      <el-select class="el-input-c" v-model="dataValue" clearable filterable :size="size" :multiple="isMultiple"
                 @change="change"
                 :collapse-tags="isMultiple"
                 :filter-method="pinYinMatch" :placeholder="placeholder" @focus="focusEvent"
                 :no-data-text="`数据加载中...`"
                 style="width: 100%"
      >
        <el-option v-for="(item, index) in dataOption" :key="index" :label="item.label"
                   :value="item.value"/>
      </el-select>
    </template>
    <template v-else>
      <el-select class="el-input-c" v-model="dataValue" clearable filterable :size="size" :multiple="isMultiple"
                 @change="change"
                 :collapse-tags="isMultiple"
                 style="width: 100%"
                 :filter-method="pinYinMatch" :placeholder="placeholder" @focus="focusEvent">
        <el-option v-for="(item,label) in dataOption" :key="item" :label="label" :value="item"/>
      </el-select>
    </template>
  </div>
</template>

<script>
import PinyinMatch from 'pinyin-match';  // 拼音缩写搜索

export default {
  name: 'PinYinMatchSelect',
  props: {
    // 数据
    data: {
      type: [Array, Object],
      default() {
        return []
      }
    },
    modelValue: {
      type: [String, Number, Array, Object],
      default: ''
    },
    // 是否多选
    isMultiple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    size: {
      type: String,
      default: 'mini'
    }
  },
  data() {
    return {
      dataOption: this.data,
      dataValue: ''
    }
  },
  watch: {
    // eslint-disable-next-line
    modelValue: function (newVal, oldVal) {
      this.dataValue = newVal
    },
    data: function (newVal) {
      this.dataOption = newVal
    }
  },
  methods: {
    pinYinMatch(val) {
      let result = {}
      this.dataOption = this.data
      if (val) {
        if (Array.isArray(this.data)) {
          // 如果是数组
          result = []
          this.data.forEach(e => {
            const m = PinyinMatch.match(e.label, val);
            if (m) {
              result.push(e)
            }
          })
        } else {
          // 如果是对象
          result = {}
          for (let i in this.data) {
            const m = PinyinMatch.match(i, val);
            if (m) {
              result[i] = i
            }
          }
        }
        this.dataOption = result
      } else {
        this.dataOption = this.data
      }
    },
    change() {
      let index = 0
      const newVal = this.dataValue
      this.$emit('update:model-value', newVal)
      if (Array.isArray(this.data)) {
        index = this.data.findIndex((item) => {
          return item.value == newVal
        })
      }
      this.dataOption = this.data
      this.$emit("change", newVal, index)
    },
    focusEvent(val) {
      this.$emit("focus", val)
    },
    getValNode(val, field) {
      let f = field ? field : 'value'
      // eslint-disable-next-line no-console
      // console.log('val', val)
      return this.data.find((value => value[f] === val))
    }
  }
}
</script>

<style scoped>
</style>
